import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";

export const TransactionsSummary = [
  {
    title: "Total Transactions",
    objKeyRepr: "totalTransaction",
    icon: <ReceiptLongOutlinedIcon fontSize="small" />,
  },
  {
    title: "Successful",
    objKeyRepr: "totalSuccess",
    icon: <CheckCircleOutlineIcon fontSize="small" color="success" />,
  },
  {
    title: "Total Settled",
    objKeyRepr: "totalSettled",
    icon: <AccountBalanceWalletOutlinedIcon fontSize="small" color="primary" />,
  },
  {
    title: "Total Pending",
    objKeyRepr: "totalPending",
    icon: <HourglassEmptyOutlinedIcon fontSize="small" color="warning" />,
  },
  {
    title: "Failed Transactions",
    objKeyRepr: "totalFailed",
    icon: <CancelOutlinedIcon fontSize="small" color="error" />,
  },
  {
    title: "Total Declined",
    objKeyRepr: "totalDeclined",
    icon: <BlockOutlinedIcon fontSize="small" color="error" />,
  },
];

export const listItemData = [
  {
    label: "Reference ID",
    val: "PTY_2cruye6niqx4yau",
    objKeyRepr: "refNo",
  },
  {
    label: "Channel",
    val: "Card",
    objKeyRepr: "channel",
  },
  {
    label: "Wayapaychat Fees",
    val: "7.50",
    objKeyRepr: "fee",
  },
  {
    label: "Date Paid",
    val: "Tuesday, 6 July 2021, 7:30pm GMT",
    objKeyRepr: "tranDate",
  },
  {
    label: "Message",
    val: "Successful",
    objKeyRepr: "status",
  },
];

export const analytics = [
  {
    label: "Card Type",
    val: "Mastercard",
    objKeyRepr: "scheme",
  },
  {
    label: "Card Number",
    val: "408408 **** 4081",
    objKeyRepr: "maskedPan",
  },
  {
    label: "Authorization",
    val: "AUTH_25jm16y8sy",
    objKeyRepr: "authorization",
  },
  {
    label: "Issuing Bank & Country",
    val: "United Bank for Africa (UBA) (NGN)",
    objKeyRepr: "issuer",
  },
  {
    label: "IP Adress",
    val: "154.73.8.97",
    objKeyRepr: "customerIpAddress",
  },
  {
    label: "Payment Processor",
    val: "Mastercard",
    objKeyRepr: "scheme",
  },
];

export const otherInformation = [
  {
    avatarIcon: "device",
    val: "Desktop",
    label: "DEVICE TYPE",
  },
  {
    avatarIcon: "tap",
    val: "1 time",
    label: "PAY BUTTON CLICKED TIME",
  },
  {
    avatarIcon: "cloud",
    val: "0 errors",
    label: "ERRORS",
  },
];
